export default __webpack_public_path__ + "static/media/NotMinotaur.5c228729.png";